import loadScriptOnce from 'load-script-once';
import analytics from '../utils/analytics.js';
import windowutils from '../utils/window.js';
import '@vimeo/player';

export default class Video {
  constructor(el, id) {
    this.initel = el;
    this.bslcontainer = document.querySelector('#footerNav > div:nth-child(2)');
    if (!document.getElementById('video-bslnotice') && this.bslcontainer) {
      try {
        this.bslcontainer.insertAdjacentHTML(
          'beforeend',
          `
            <span id="video-bslnotice">
                <h2>British Sign Language</h2>
                <p>BSL users can contact us via contactSCOTLAND-BSL, the on-line British Sign Language interpreting video relay service.</p>
                <ul><li><a href="https://contactscotland-bsl.org/">Find out more about BSL assistance: contactSCOTLAND</a></li></ul>
            </span>
            `
        );
      } catch (error) {
        console.log(error);
      }
    }
    this.iscalltoaction = el.classList.contains('calltoaction');
    this.isfullwidth = el.classList.contains('fullwidth');
    this.el =
      el.tagName === 'A'
        ? el
        : el.querySelector('a')
          ? el.querySelector('a')
          : null;
    if (this.el) {
      this.parent = el.parentNode;
      this.onlyvideocontent = this.parent.childElementCount == 2;
      this.onlyvideocontent
        ? this.parent.classList.add('video-feature')
        : false;
      this.classlist = el.classList;
      this.id = `video_${id}`;
      this.source = this.el
        ? this.el.getAttribute('href').replace('?testing', '')
        : false;
      if (this.source) {
        //this.host = this.source.includes("youtu") ? "youtube" : this.source.includes("vimeo") ? "vimeo" : this.source.includes("facebook") ? "facebook" : "media";
        this.host = this.getHost(this.source);
      }
      this.title = this.el
        ? this.el.textContent != ''
          ? this.el.textContent
          : this.id
        : this.id;
      this.thumbnailgenerator = '/ffmpeg/thumbgen.php?file=';
      this.loaded = this.el.dataset.videoloaded;
      this.types = [
        {
          name: 'largeplayer',
          class: 'largeplayer',
          wrapperclasses: [
            'flex-video',
            'widescreen',
            `${this.host}-wrapper`,
            this.classlist.contains('portrait') ? 'portrait' : '',
          ],
        },
        {
          name: 'smallplayer',
          class: 'smallplayer',
          wrapperclasses: [
            'large-6',
            'columns',
            'right',
            'videoWrapper',
            `${this.host}-wrapper`,
          ],
        },
        {
          name: 'popupplayer',
          class: 'popupplayer',
          wrapperclasses: [
            'video-popup',
            'close-popup',
            `${this.host}-wrapper`,
          ],
        },
        {
          name: 'mp3',
          class: 'mp3',
          wrapperclasses: ['widescreen', 'mp3player', `${this.host}-wrapper`],
        },
      ];

      try {
        if (
          this.host !== 'media' ||
          (this.host == 'media' && this.source.includes('/feeds/'))
        ) {
          let observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.source ? this.loadplayer() : false;
                  observer.unobserve(entry.target);
                  window.dispatchEvent(new Event('resize'));
                }
              });
            },
            { rootMargin: '300px 0px 0px 0px', threshold: 0 }
          );
          observer.observe(this.el);
        } else {
          this.el.remove();
        }
      } catch (error) {
        console.log(error);
      }
    }
    //  console.log(this);
  }

  getHost(source) {
    if (source.includes('youtu')) {
      return 'youtube';
    } else if (source.includes('vimeo')) {
      return 'vimeo';
    } else if (source.includes('facebook')) {
      return 'facebook';
    } else if (source.includes('microsoftstream')) {
      return 'stream';
    } else if (source.includes('mediaspace')) {
      return 'kaltura';
    } else {
      return 'media';
    }
  }

  gettype() {
    return this.types.find((type) => {
      return this.classlist.contains(type.class);
    });
  }

  getyoutubeid() {
    const sourcearray = this.source.split('/');
    if (this.source.includes('shorts')) {
      return sourcearray[4];
    }
    return this.source.includes('youtu.be')
      ? sourcearray[3].trim().split('?')[0]
      : sourcearray[3].split('=')[1].trim();
  }

  getvimeoid() {
    const sourcearray = this.source.split('/');
    return sourcearray[3];
  }

  getfacebookid() {
    const sourcearray = this.source.split('/');
    return sourcearray[3];
  }

  getStreamid() {
    const sourcearray = this.source.split('/');
    return sourcearray[4];
  }

  getKalturaid() {
    const sourcearray = this.source.split('/');
    return sourcearray[5];
  }

  getKalturaTitle() {
    const sourcearray = this.source.split('/');
    return sourcearray[4];
  }

  getthumbnail() {
    if (this.el.querySelector('img')) {
      //console.log(this.el.querySelector('img').src);
      return this.el.querySelector('img').getAttribute('src');
    } else if (this.host === 'media') {
      return '/3t4/img/video-thumbnail.png';
      // return this.thumbnailgenerator + this.source;
    } else if (this.host === 'youtube') {
      const id = this.getyoutubeid();
      /*const request = async () => {
                const response = await fetch(`/feeds/media/ytthumbnail.html?ytid=${id}`);
                const json = await response.text();
                return json;
            }
            const val = await request();
            console.log(val);*/
      return `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
    } else if (this.host === 'vimeo') {
      const id = this.getvimeoid();
      return `https://www.gla.ac.uk/feeds/media/thumbnail.html?id=${id}`;
    } else if (this.host === 'facebook') {
      const id = this.facebookid();
      return ``;
    } else if (this.host === 'stream') {
      const id = this.getStreamid();
      return '/3t4/img/video-thumbnail.png';
    } else if (this.host === 'kaltura') {
      const id = this.getKalturaid();
      return `https://cfvod.kaltura.com/p/4157173/sp/415717300/thumbnail/entry_id/${id}/version/100001/width/1280/height/720`;
    }
  }

  getplayer() {
    if (this.host === 'youtube') {
      return `<div id="youtube_${this.id}"><img src="${this.getthumbnail()}" alt="" /></div>`;
    } else if (this.host === 'media') {
      return `<div id="jwplayer_${this.id}"><img src="${this.getthumbnail()}" alt="" /></div>`;
    } else if (this.host === 'vimeo') {
      return `<div id="vimeo_${this.id}"><img src="${this.getthumbnail()}" alt="" /></div>`;
    } else if (this.host === 'stream') {
      return `<div id="stream_${this.id}"></div>`;
    } else if (this.host === 'kaltura') {
      return `<div id="kaltura_${this.id}"></div>`;
    }
  }

  getplayerwrapper() {
    const type = this.gettype();
    const largewrapper = `
            <div>${this.getplayer()}</div>
        `;

    const smallwrapper = `
            <div>${this.getplayer()}<div style="clear:both;"></div>
        `;
    const popupwrapper = `
            <div class="pop-wrapper">${this.getplayer()}</div>
        `;
    return type.name === 'smallplayer'
      ? smallwrapper
      : type.name === 'popupplayer'
        ? popupwrapper
        : largewrapper;
  }

  replaceelement() {
    const type = this.gettype();
    const newel = document.createElement('div');
    newel.id = this.id;
    type.wrapperclasses.forEach((wrapperclass) => {
      if (wrapperclass !== '') {
        try {
          newel.classList.add(wrapperclass);
        } catch (e) {
          console.log(e);
        }
      }
    });
    newel.innerHTML = this.getplayerwrapper();
    if (type.name === 'popupplayer') {
      newel.style.display = 'none';
      newel.insertAdjacentHTML(
        'beforeend',
        `<button class="close-popup" aria-label="close video" data-videoid="${this.id}">close</button>`
      );
      document.querySelector('body').appendChild(newel);
      if (this.iscalltoaction) {
        let classes = [...this.initel.classList].join(' ');
        let calltoaction = `<span class="${classes} video-popup-placeholder" data-videoid="${this.id}">${this.initel.textContent}</span>`;
        this.initel.classList.add('video-popup-placeholder');
        this.initel.dataset.videoid = this.id;
        this.initel.insertAdjacentHTML('afterend', calltoaction);
        this.initel.parentNode.removeChild(this.initel);
      } else {
        let popuphtml = `<div tabindex="0" aria-label="${this.title.trim() !== '' ? this.title : 'play video'}" role="button" class="video-popup-placeholder columns ${this.isfullwidth ? 'fullwidth large-12' : 'right large-6'}  videoWrapper" data-videoid="${this.id}"><img src="${this.getthumbnail()}" alt="" role="presentation" /><div class="playoverlay"></div></div>`;
        if (this.parent.classList.contains('tileImage')) {
          popuphtml = `<div tabindex="0" aria-label="${this.title.trim() !== '' ? this.title : 'play video'}" role="button" class="video-popup-placeholder" data-videoid="${this.id}"><img class="video-popup-thumbnail" src="${this.getthumbnail()}" alt="" role="presentation" /><div class="playoverlay"></div></div>`;
        }
        this.initel.insertAdjacentHTML('afterend', popuphtml);
        this.initel.parentNode.removeChild(this.initel);
      }
    } else {
      this.initel.parentNode.replaceChild(newel, this.initel);
    }
    this.popupclickhandler();
  }

  loadplayer() {
    this.replaceelement();
    this.el.dataset.videoloaded = true;
    switch (this.host) {
      case 'media':
        this.loadjwplayer();
        break;
      case 'youtube':
        this.loadyoutube();
        break;
      case 'vimeo':
        this.loadvimeo();
        break;
      case 'facebook':
        this.loadfacebook();
        break;
      case 'stream':
        this.loadstream();
        break;
      case 'kaltura':
        this.loadKaltura();
        break;
      default:
        break;
    }
  }

  loadjwplayer() {
    const jwplayerscript = '/3t4/js/libs/jwplayer/jwplayer.js';
    const source = this.source.replace(
      'http://media.gla.ac.uk/web',
      'https://www.gla.ac.uk/feeds/media/pt.html?media='
    );
    //const source = this.source;
    const type = this.gettype();
    let ratio = '';
    type.name === 'mp3' ? (ratio = '16:3') : (ratio = '16:9');
    loadScriptOnce(jwplayerscript)
      .then(() => {
        jwplayer.key = 'yGyYXaHqa/lyeG0ScFArAF3gTiVPO42bByXM2A==';
        jwplayer(`jwplayer_${this.id}`).setup({
          file: source,
          width: '100%',
          aspectratio: ratio,
          title: this.title,
          image: this.getthumbnail(),
          type: 'mp4',
          skin: {
            name: 'bekle',
          },
          primary: 'html5',
          preload: 'none',
          ga: {},
          abouttext: 'the University of Glasgow',
          aboutlink: 'http://www.gla.ac.uk',
        });
      })
      .catch((err) => console.error('failed to load!', err));
    //  this.popupclickhandler();
  }

  loadyoutube() {
    const youtubescript = 'https://www.youtube.com/iframe_api';
    loadScriptOnce(youtubescript).then(() => {
      let ytloaded = setInterval(() => {
        if (YT.loaded) {
          this.runyoutube();
          clearInterval(ytloaded);
        }
      }, 100);
    });
  }

  loadvimeo() {
    const vimeoscript = '/3t4/js/libs/vimeo/dist/player.js';
    loadScriptOnce(vimeoscript).then(() => {
      fetch(`/feeds/media/vimeo.html?id=${this.getvimeoid()}`)
        .then((response) => response.json())
        .then((data) => {
          const ratio = data.response == 'success' ? data.ratio : 0.5625;
          const resizeiframe = () => {
            const wrapper = document.getElementById(`vimeo_${this.id}`);
            const iframeheight = wrapper.offsetWidth * ratio;
            wrapper.querySelector('iframe').height = `${iframeheight}px`;
          };

          document
            .getElementById(`vimeo_${this.id}`)
            .removeChild(
              document.getElementById(`vimeo_${this.id}`).querySelector('img')
            );
          document
            .getElementById(`vimeo_${this.id}`)
            .insertAdjacentHTML(
              'beforeend',
              `<iframe src="https://player.vimeo.com/video/${this.getvimeoid()}?dnt=1" width="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
            );
          this.vimeoiframe = document
            .getElementById(`vimeo_${this.id}`)
            .querySelector('iframe');
          this.vimeoiframe.title = this.title;
          this.vimeoplayer = new Vimeo.Player(this.vimeoiframe);
          this.vimeoplayer.on('play', () => {
            analytics.logevent('vimeo video', 'play', this.getvimeoid());
          });
          this.vimeoplayer.on('pause', () => {
            analytics.logevent('vimeo video', 'paused', this.getvimeoid());
          });
          this.vimeoplayer.on('ended', () => {
            analytics.logevent('vimeo video', 'ended', this.getvimeoid());
          });
          resizeiframe();
          window.addEventListener('resize', (e) => {
            resizeiframe();
          });
        });
    });
    return true;
  }

  loadfacebook() {
    const facebookscript =
      'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2';
    document.getElementById(`facebook_${this.id}`).insertAdjacentHTML(
      'beforeend',
      `
            <div id="fb-root"></div>
        `
    );
    loadScriptOnce(facebookscript).then(() => {
      document
        .getElementById(`facebook_${this.id}`)
        .removeChild(
          document.getElementById(`facebook_${this.id}`).querySelector('img')
        );
      document.getElementById(`facebook_${this.id}`).insertAdjacentHTML(
        'beforeend',
        `
                <iframe src="https://player.vimeo.com/video/${this.getfacebookid()}?dnt=1" width="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            `
      );
    });
    return true;
  }

  loadstream() {
    this.getStreamid();
    document.getElementById(`stream_${this.id}`).insertAdjacentHTML(
      'beforeend',
      `
        <div style='max-width: 1280px'><div style='position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden;'><iframe width="1280" height="720" src="https://web.microsoftstream.com/embed/video/${this.getStreamid()}?autoplay=false&showinfo=true" allowfullscreen style="border:none; position: absolute; top: 0; left: 0; right: 0; bottom: 0; height: 100%; max-width: 100%;"></iframe></div></div>
        <div style="clear:both;"></div>
        `
    );
  }

  loadKaltura() {
    const entryId = this.getKalturaid();

    if (!entryId) {
      console.error('No entry ID found');
      return;
    }

    console.log(`Preparing MediaSpace video: ${entryId}`);

    // Store the entry ID but DON'T create the iframe yet
    this.kalturaIframeId = `kaltura_iframe_${this.id}`;
    this.kalturaEntryId = entryId;
    this.kalturaLoaded = false;

    // Create placeholder container
    document.getElementById(`kaltura_${this.id}`).insertAdjacentHTML(
      'beforeend',
      `
        <div id="kaltura_container_${this.id}" style='max-width: 1280px'>
            <div style='position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; background: #000;'>
                <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white;">
                    Loading player...
                </div>
            </div>
            <div style="clear:both;"></div>
        </div>
    `
    );
  }

  // Call this when the modal opens or when you want to actually load the video
  activateKaltura() {
    if (this.kalturaLoaded) return; // Already loaded

    const container = document.getElementById(`kaltura_container_${this.id}`);
    if (!container) return;

    console.log(`Activating Kaltura player: ${this.kalturaEntryId}`);

    container.innerHTML = `
        <div style='position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden;'>
            <iframe 
                id="${this.kalturaIframeId}"
                src="https://mediaspace.gla.ac.uk/embed/secure/iframe/entryId/${this.kalturaEntryId}/uiConfId/52235382?autoplay=false"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
                allowfullscreen 
                webkitallowfullscreen 
                mozAllowFullScreen 
                allow="autoplay *; fullscreen *; encrypted-media *" 
                frameborder="0"
                title="Kaltura Video Player">
            </iframe>
        </div>
        <div style="clear:both;"></div>
    `;

    this.kalturaLoaded = true;
    this.initKalturaAPI();
  }

  initKalturaAPI() {
    const iframe = document.getElementById(this.kalturaIframeId);
    if (!iframe) return;

    iframe.addEventListener('load', () => {
      console.log('Kaltura iframe loaded');
    });
  }

  stopKaltura() {
    const iframe = document.getElementById(this.kalturaIframeId);
    if (!iframe) return;

    iframe.contentWindow.postMessage(
      {
        method: 'pause',
      },
      '*'
    );
  }

  destroyKaltura() {
    const container = document.getElementById(`kaltura_container_${this.id}`);
    if (container) {
      container.innerHTML = `
            <div style='position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; background: #000;'>
                <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white;">
                    Player stopped
                </div>
            </div>
        `;
    }
    this.kalturaLoaded = false;
  }

  runyoutube() {
    let player = new YT.Player(`youtube_${this.id}`, {
      height: '100%',
      width: '100%',
      videoId: this.getyoutubeid(),
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        autoplay: false,
        loop: 0,
        controls: 1,
        showinfo: 0,
        autohide: 1,
        modestbranding: 1,
        vq: 'hd1080',
        enablejsapi: 1,
        playsinline: 1,
      },
      events: {
        onReady: function (event) {
          if (typeof event.target.setSphericalProperties === 'function') {
            event.target.setSphericalProperties({
              yaw: 90,
              pitch: 10,
              fov: 80,
            });
          }
        },
        onStateChange: function (event) {
          const states = {
            '-1': 'unstarted',
            0: 'ended',
            1: 'playing',
            2: 'paused',
            3: 'buffering',
            5: 'video cued',
          };
          analytics.logevent(
            'youtube video',
            states[event.data],
            event.target.getVideoData().title
          );
        },
      },
    });
  }

  popupclickhandler() {
    [...document.querySelectorAll('.video-popup-placeholder')].forEach((el) => {
      if (!el.dataset.clickhandler) {
        el.addEventListener('click', () => {
          const popupelement = document.getElementById(el.dataset.videoid);
          popupelement.style.display = 'block';
          popupelement.querySelector('.close-popup').focus();
          if (this.host === 'media') {
            jwplayer(`jwplayer_${el.dataset.videoid}`).play();
          } else if (this.host === 'youtube') {
            document
              .getElementById(`youtube_${this.id}`)
              .contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                '*'
              );
          } else if (this.host === 'vimeo') {
            this.vimeoplayer.play();
          } else if (this.host === 'kaltura') {
            this.activateKaltura();
          }
        });
        el.addEventListener('keypress', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            event.target.click();
          }
        });
        el.dataset.clickhandler = true;
      }
    });
    [...document.querySelectorAll('.close-popup')].forEach((el) => {
      if (!el.dataset.clickhandler) {
        el.addEventListener('click', () => {
          document.getElementById(this.id).style.display = 'none';
          if (this.host === 'media') {
            el.dataset.videoid
              ? jwplayer(`jwplayer_${el.dataset.videoid}`).stop()
              : false;
          } else if (this.host === 'youtube') {
            document
              .getElementById(`youtube_${this.id}`)
              .contentWindow.postMessage(
                '{"event":"command","func":"stopVideo","args":""}',
                '*'
              );
          } else if (this.host === 'vimeo') {
            this.vimeoplayer.pause();
          } else if (this.host === 'kaltura') {
            this.stopKaltura();
            this.destroyKaltura();
          }
        });
        el.addEventListener('keypress', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            event.target.click();
          }
        });
        el.dataset.clickhandler = true;
      }
    });
  }
}
